import React, { Component } from 'react';
import Highcharts from 'highcharts/highstock'
import HighchartsReact from 'highcharts-react-official'
import highchartsMore from "highcharts/highcharts-more.js";
import xRange from "highcharts/modules/xrange.js";
import styles from './styles';
import { withStyles } from '@material-ui/core/styles';
import compose from 'recompose/compose';
import Typography from '@material-ui/core/Typography';
import CircularProgress from '@material-ui/core/CircularProgress';
import { Grid } from '@material-ui/core';
highchartsMore(Highcharts);
xRange(Highcharts);


Highcharts.setOptions ({
    lang: {
        months: [
            'Enero', 'Febrero', 'Marzo', 'Abril',
            'Mayo', 'Junio', 'Julio', 'Agosto',
            'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
        ],
        shortMonths: [
            'Ene', 'Feb', 'Mar', 'Abr',
            'Mar', 'Jun', 'Jul', 'Ag',
            'Sep', 'Oct', 'Nov', 'Dic'
        ],
        weekdays: [
            'Domingo', 'Lunes', 'Martes', 'Miercoles',
            'Jueves', 'Viernes', 'Sabado'
        ],
        shortWeekdays: ['D','L' ,'M', 'Mi', 'J', 'V', 'S']
    }
}) 

class AvailabilityConsolidated extends Component {

    constructor(props) {
        super(props)
        this.state = {
            isLoading:true,
            contSteps:0,
            dataGroup:this.props.objs,
            chartOptionsStackedBarConsolidated: {},
        }
    }
    componentDidMount() {
        this.processData();
    }

	nameEvent(eventoId) {
        let nombre = '';
        if (eventoId === '1') {
            nombre = 'uptime';
        } else if (eventoId === '2') {
            nombre = 'downtime';
        } else if (eventoId === '3') {
            nombre = 'downtime parcial';
        } else if (eventoId === '7') {
            nombre = 'no monitoreo';
        } else if (eventoId === '9') {
            nombre = 'evento cliente';
        }
        return nombre;
    }

    getListEventForNodeDowntime(listEvents) {
        const estados = [];
        listEvents.forEach(item => {
            const dataObj = item.data;
            if (dataObj) {
                const obj = dataObj.obj;
                if (obj) {
                    const nodo = obj.Nodo;
                    if (Array.isArray(nodo)) {
                        nodo.forEach(nodoItem => {
                            if (nodoItem && nodoItem.estado) {
                                nodoItem.estado.forEach(estado => {
                                    estados.push(estado);
                                });
                            }
                        });
                    }
                }
            }
        })

        let listEventsStep = estados.sort((a, b) => new Date(a['fecha_desde']) - new Date(b['fecha_desde']));
        var listEventsProcesados = [];

        let dateEnd = new Date();
        var dateStartCompare = new Date(dateEnd);
        dateStartCompare.setDate(dateStartCompare.getDate() - 1);

        var dateStartFinal = new Date(dateEnd);
        dateStartFinal.setDate(dateStartFinal.getDate() - 1);

        var nombreAColor = {
            "1": "#41B900",
            "2": "#C2272D",
            "3": "#FFC600",
            "7": "#A9A9A9",
            "9": "blue"
        };
        var estadoOperativo = {
            "1": "Operativo (verificado desde todos los ISP de los objetivos)",
            "2": "Caído o no operativo",
            "3": "Operativo (algunos objetivos con ISP con problemas)",
            "7": "Rango sin monitoreo",
            "9": "Mantenimiento programado"
        };
        
        let isFirstEvento = true;
        let dictElementStatusOrder = {};
        var terminoMasBajaAnterior = null;
        var eventIdAnterior = null;
        let lastElement = listEventsStep[listEventsStep.length - 1];
        while (dateStartCompare < new Date(lastElement.fecha_hasta)) {
            let dateEndCompare = null;
            var inicioMasBaja = null;
            var terminoMasBaja = null;
            var isFirstStart = true;
            let countUptime = 0;
            let countDowntime = 0;
            let countDownParcial = 0;
            let countNoMonitoreo = 0;
            let countCliente = 0;
            let countObjs = 0;
            for (let index = 0; index < listEventsStep.length; index++) {
                let eventStep = listEventsStep[index];
                if (new Date(eventStep['fecha_hasta']) <= dateStartCompare) {
                    continue;
                }

                if (eventStep['nombre'] === 'downtime') {
                    countDowntime++;
                } else if (eventStep['nombre'] === 'downtime parcial') {
                    countDownParcial++;
                } else if (eventStep['nombre'] === 'no monitoreo') {
                    countNoMonitoreo++;
                } else if (eventStep['nombre'] === 'evento cliente') {
                    countCliente++;
                } else if (eventStep['nombre'] === 'uptime') {
                    countUptime++;
                }

                if (!dateEndCompare || dateEndCompare > new Date(eventStep['fecha_hasta'])) {
                    dateEndCompare = new Date(eventStep['fecha_hasta']);
                }
                if (isFirstStart == false && new Date(inicioMasBaja) > new Date(eventStep['fecha_desde'])) {
                    inicioMasBaja = eventStep['fecha_desde']
                }
                if (isFirstStart == false && new Date(terminoMasBaja) > new Date(eventStep['fecha_hasta'])) {
                    terminoMasBaja = eventStep['fecha_hasta']
                }
                if (isFirstStart == true) {
                    inicioMasBaja = eventStep['fecha_desde']
                    terminoMasBaja = eventStep['fecha_hasta']
                    isFirstStart = false;
                }
                countObjs++;
                if (countObjs === listEvents.length) {
                    break;
                }
            }

            var eventId = '';
            if (countUptime > 0 && countUptime + countNoMonitoreo === listEvents.length) {
                eventId = '1';
            }
            if (countDowntime > 0 && countDowntime + countNoMonitoreo === listEvents.length) {
                eventId = '2';
            }
            if (countDownParcial > 0 && countDownParcial + countNoMonitoreo === listEvents.length) {
                eventId = '3';
            }
            if (countNoMonitoreo === listEvents.length || (countNoMonitoreo > 0 && countUptime + countDowntime + countDownParcial + countCliente === 0)) {
                eventId = '7';
            }
            if (countCliente === listEvents.length  || (countCliente > 0 && countUptime + countDowntime + countDownParcial + countCliente === 0)) {
                eventId = '9';
            }
            if (countUptime > 0 && countDowntime > 0 && countUptime + countDowntime + countNoMonitoreo === listEvents.length) {
                eventId = '3';
            }
            if (countDownParcial > 0 && countDowntime > 0 && countUptime + countNoMonitoreo === 0) {
                eventId = '3';
            }
            if (countUptime > 0 && countDownParcial > 0 && countUptime + countDownParcial + countNoMonitoreo === listEvents.length) {
                eventId = '3';
            }
            //verifica primer evento
            if (isFirstEvento == false) {
                //verifica si id de evento es igual al anterior, en caso de de ser el mismo
                //asigna fecha de termino mas baja al ultimo elemento de la lista
                //para que el evento continue con el mismo color
                //en caso contrario crea un nuevo evento consolidado
                if (eventIdAnterior === eventId) {
                    listEventsProcesados[listEventsProcesados.length -1].data[0].x2 = new Date(terminoMasBaja).getTime()
                }else{
                    dictElementStatusOrder = {
                        'name':estadoOperativo[eventId],
                        'pointWidth': 40,
                        'data':[{
                            'x': new Date(terminoMasBajaAnterior).getTime(),
                            'x2': new Date(terminoMasBaja).getTime(),
                            'y': 0,
                            'color': nombreAColor[eventId],}
                        ]
                    };
                    listEventsProcesados.push(dictElementStatusOrder);
                }
            }
            //verifica si es el primer evento
            //en caso de serlo crea un nuevo evento consolidado
            if (isFirstEvento == true) {
                dictElementStatusOrder = {
					'name':estadoOperativo[eventId],
                    'pointWidth': 40,
                    'data':[{
                        'x': new Date(inicioMasBaja).getTime(),
                        'x2': new Date(terminoMasBaja).getTime(),
                        'y': 0,
                        'color': nombreAColor[eventId],}
                    ]
				};
				listEventsProcesados.push(dictElementStatusOrder);
                isFirstEvento = false;
            }

			if (dateEndCompare === null) {
				dateEndCompare = new Date(dateEnd);
			}
            //asigna valores a variables para comparar con el siguiente evento
            eventIdAnterior = eventId
            terminoMasBajaAnterior = terminoMasBaja
			dateStartCompare = dateEndCompare;
		}
		return listEventsProcesados;
	}

    processData=()=>{
        const {dataGroup}=this.state
        var listDates = this.getListEventForNodeDowntime(dataGroup)

        this.setState({ 
            
            isLoading:false,
            chartOptionsStackedBarConsolidated: {
                time: {
                    useUTC: false
                },
                chart: {
                    type: 'xrange',
                    height: 90,
                },
                title: {
                    text: null
                },
                
                xAxis: {
                    type: 'datetime',
                    gridLineWidth: 0,
                    labels: {
                        enabled: false
                    },
                    visible: false
                },
                pane: {
                    size: '150%',
                },
                yAxis: {
                    categories: ['<b>CONSOLIDADO</b>'],
                    title: {
                        text: ''
                    },
                    gridLineWidth: 0,
                    reversed: true,
                    labels: {
                        useHTML:true,
                        style:{
                            width:'100px',
                            whiteSpace:'normal'
                        },
                        step: 1,
                        formatter: function () {
                            return '<div align="center" style="word-wrap: break-word;word-break: break-all;width:100px">' + this.value + '</div>';
                        }
                    },
                    
                },
                series: listDates,
                plotOptions: {
                    series: {
                        borderRadius: '0px',
                        borderColor: 'transparent',
                        pointWidth: 10,
                        turboThreshold: 30000,
                        grouping: false
                    }
                },
                credits: {
                    enabled: false
                },
                tooltip: {
                    xDateFormat: '%A, %b %e, %Y %H:%M:%S',
                    enabled: true,
                },
                
                legend: {
                    enabled: false
                },
                
            },
        })
    }
    

    render() {
        const {isLoading, chartOptionsStackedBarConsolidated}=this.state
        const {classes}=this.props
        if (isLoading===true) {
            return(
                    <Grid item lg={12} xl={12}>
                        <Typography
                        className={classes.circular}
                            variant="caption"
                            >
                            <CircularProgress
                            className={classes.circular}
                            variant="indeterminate"
                            size={8}
                            thickness={1}
                            
                            />
                            Cargando Grupos...
                        </Typography>
                    </Grid>
            )
        }else{
            return(
                    <Grid item lg={12} xl={12} >
                        <HighchartsReact
                            highcharts={Highcharts}
                            options={chartOptionsStackedBarConsolidated} 
                        />
                    </Grid>
                
            )
        }
   
    }
}
export default
    compose(withStyles(styles))(AvailabilityConsolidated);